import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import LeverandorLogos from "../components/LeverandorLogos";


export default function Home() {
  const [countdown, setCountdown] = useState("");
  const [weather, setWeather] = useState(null);

  // ⏳ Beregn nedtelling
    useEffect(() => {
        const departure = new Date("2025-08-28T11:00:00+02:00");

        let animationFrameId;

        const updateCountdown = () => {
            const now = new Date();
            const diff = departure - now;

            if (diff <= 0) {
            setCountdown("✈️ Reisen er i gang – vi sees på tur!");
            return;
            }

            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((diff / (1000 * 60)) % 60);
            const seconds = Math.floor((diff / 1000) % 60);

            setCountdown(`${days}d ${hours}t ${minutes}min ${seconds}s igjen`);

            animationFrameId = requestAnimationFrame(() => {
            setTimeout(updateCountdown, 1000);
            });
        };

        updateCountdown();

        return () => cancelAnimationFrame(animationFrameId);
}, []);

  // 🌤️ Hent vær for Gdansk
  useEffect(() => {
  const fetchWeather = async () => {
    try {
      const apiKey = process.env.REACT_APP_WEATHER_API_KEY;
      const response = await fetch(
        `https://api.openweathermap.org/data/2.5/weather?q=Gdansk,PL&appid=${apiKey}&units=metric&lang=no`
      );
      if (!response.ok) {
        throw new Error(`HTTP ${response.status} – ${response.statusText}`);
      }
      const data = await response.json();
      if (data?.main?.temp && data.weather && data.weather.length > 0) {
        setWeather({
          temp: data.main.temp.toFixed(1),
          desc: data.weather[0].description,
          icon: data.weather[0].icon,
        });
      } else {
        console.warn("Ugyldig eller tom værdata:", data);
        setWeather(null);
      }
    } catch (err) {
      console.error("Klarte ikke hente værdata:", err);
      setWeather(null);
    }
  };

  fetchWeather();
}, []);

  return (
  <div style={{ padding: "2rem", maxWidth: "900px", margin: "0 auto" }}>
    {/* 🎉 Velkomst-banner med bakgrunnsbilde */}
    <div
      style={{
        backgroundImage: "linear-gradient(rgba(255, 255, 255, 0.35), rgba(255, 255, 255, 0.75)), url('/img/Sheraton-strand.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "white",
        borderRadius: "12px",
        padding: "2rem",
        marginBottom: "2rem",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        textAlign: "center",
      }}
    >
      <h1 style={{ marginBottom: "0.5rem", color: "#000000" }}>Velkommen til</h1>
      <h2 style={{ fontSize: "2rem", color: "#000000" }}>Dekkpartner Gdansk 2025</h2>
      
      <p style={{ fontSize: "2rem" ,fontWeight: "bold", color: "#000000", marginTop: "1rem" }}>
        ⏳ {countdown}
      </p>
      {weather && (
        <p style={{ marginTop: "0.5rem", color: "#000000", fontStyle: "italic",  }}>
          🌤️ Været i Gdansk nå: {weather.temp}°C – {weather.desc}{" "}
          <img
            src={`https://openweathermap.org/img/wn/${weather.icon}@2x.png`}
            alt="Værikon"
            style={{ verticalAlign: "middle", width: "40px" }}
          />
        </p>
      )}
    </div>

    {/* ✨ Intro */}
    <div style={{ marginBottom: "2rem", lineHeight: "1.6" }}>
        <LeverandorLogos />
      <p>
        Her finner du all informasjonen du trenger for årets fellestur til Gdansk og Sopot:
        program dag for dag, detaljer om hotell og transport, samt kontaktinformasjon.
      </p>
      <p>
        Hold deg oppdatert og gled deg til en minnerik opplevelse!
      </p>
    </div>


      {/* 🧭 Navigasjonskort */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "1.5rem",
          justifyContent: "space-between",
        }}
      >
        <NavCard title="📅 Program" description="Se dag-for-dag-programmet" link="/program" />
        <NavCard title="🏨 Informasjon" description="Praktisk info om overnatting" link="/hotell" />
        <NavCard title="📞 Kontakt" description="Viktige kontaktpersoner" link="/kontakt" />
      </div>
      {/* 🎧 Avspillbar lydknapp */}
            <div style={{ marginTop: "2rem", textAlign: "center" }}>
            <audio controls>
                <source src="/audio/intro.mp3" type="audio/mpeg" />
                Din nettleser støtter ikke lydavspilling.
            </audio>
            <p style={{ marginTop: "0.5rem", fontSize: "0.95rem", color: "#555" }}>
                Trykk for å høre en velkomstmelding!
            </p>
            </div>
    </div>
  );
}

function NavCard({ title, description, link }) {
  return (
    <Link
      to={link}
      style={{
        flex: "1 1 250px",
        backgroundColor: "#f9f9f9",
        padding: "1.5rem",
        borderRadius: "10px",
        textDecoration: "none",
        color: "#06111e",
        boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
        transition: "transform 0.2s",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.02)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
    >
      <h3 style={{ marginBottom: "0.5rem" }}>{title}</h3>
      <p style={{ color: "#333", margin: 0 }}>{description}</p>
    </Link>
    
  );
}
